import React from 'react'
// import {EVENTS} from "./events"
// import { Scheduler } from "@aldabil/react-scheduler";


export default function EventScheduling () {
  return (
	<>
	</>
    // <Scheduler
    //   view="week"
    //   events={[]}
    //   selectedDate={new Date( )}
    // />
  );
}





// import React, { useState, useCallback, useMemo } from 'react'
// import format from "date-fns/format";
// import getDay from "date-fns/getDay";
// import parse from "date-fns/parse";
// import startOfWeek from "date-fns/startOfWeek";
// import { Calendar,Views, dateFnsLocalizer } from "react-big-calendar";
// import "react-big-calendar/lib/css/react-big-calendar.css";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// // import Popup from './Popup';


// const locales = {
// 	"en-US": require("date-fns/locale/en-US"),
// };
// const localizer = dateFnsLocalizer({
// 	format,
// 	parse,
// 	startOfWeek,
// 	getDay,
// 	locales,
// });

// const events = [
// 	{
// 		title: "Big Meeting",
// 		allDay: true,
// 		start: new Date(2021, 6, 0),
// 		end: new Date(2021, 6, 0),
// 	},
// 	{
// 		title: "Vacation",
// 		start: new Date(2021, 6, 7),
// 		end: new Date(2021, 6, 10),
// 	},
// 	{
// 		title: "Conference",
// 		start: new Date(2021, 6, 20),
// 		end: new Date(2021, 6, 23),
// 	},
// ];


// function EventScheduling() {
// 	const [newEvent, setNewEvent] = useState({ title: "", start: "", end: "" });
// 	const [allEvents, setAllEvents] = useState(events);
// 	const [PopUp, setPopUp]=useState()
	

// 	function handleAddEvent() {

		// for (let i = 0; i < allEvents.length; i++) {

		// 	const d1 = new Date(allEvents[i].start);
		// 	const d2 = new Date(newEvent.start);
		// 	const d3 = new Date(allEvents[i].end);
		// 	const d4 = new Date(newEvent.end);
		// 	/*
		// 		console.log(d1 <= d2);
		// 		console.log(d2 <= d3);
		// 		console.log(d1 <= d4);
		// 		console.log(d4 <= d3);
		// 		  */

		// 	if (
		// 		((d1 <= d2) && (d2 <= d3)) || ((d1 <= d4) &&
		// 			(d4 <= d3))
		// 	) {
		// 		alert("CLASH");
		// 		break;
		// 	}

		// }


	// 	setAllEvents([...allEvents, newEvent]);
	// }

		
	
	// const handleSelectEvent = useCallback(
	// 	(event) => window.alert(event.title),
	// 	[]
	// )
	
	// const { defaultDate, scrollToTime } = useMemo(
	// 	() => ({
	// 		defaultDate: new Date(2015, 3, 12),
	// 		scrollToTime: new Date(1970, 1, 1, 6),
	// 	}),
	// 	[]
	// )

	// const handleSelectSlot = ({start,end})=> {
	// 	const title = window.prompt("New event Name")
	// 	if(title){
	// 		setAllEvents((prev)=>[...prev,{start,end,title}])
	// 	}
	// 	return[setAllEvents]
	// }

	// return (
	// 	<div className="App">
	// 		<h1>Event Scheduled</h1>
			{/* <h2>Add New Event</h2> */}
			{/* <div>
				<input type="text"
					placeholder="Add Title"
					style={{ width: "20%", marginRight: "10px" }}
					value={newEvent.title}
					onChange={(e) => setNewEvent({ ...newEvent, title: e.target.value })}
				/>

				<DatePicker
					placeholderText="Start Date"
					style={{ marginRight: "10px" }}
					selected={newEvent.start}
					onChange={(start) => setNewEvent({ ...newEvent, start })}
				/>
				<DatePicker
					placeholderText="End Date"
					selected={newEvent.end}
					onChange={(end) => setNewEvent({ ...newEvent, end })}
				/>
				<button stlye={{ marginTop: "10px" }} onClick={handleAddEvent}>
					Add Event
				</button>
			</div> */}
// 			<Calendar
// 				events={allEvents}
// 				startAccessor="start"
// 				endAccessor="end"
// 				style={{ height: 500, margin: "50px" }}
// 				// defaultDate={defaultDate}
// 				defaultView={Views.WEEK}
// 				localizer={localizer}
// 				// onSelectEvent={handleSelectEvent}
// 				onSelectSlot={handleSelectSlot}

// 				selectable
// 				timeslots={8}
// 				// scrollToTime={scrollToTime}
// 				showMultiDayTimes
// 			/>
// 		</div>
// 	);
// }
// export default EventScheduling;


